/**
 * API routes for Partner Platform — separate from player auth routes.
 */
export const PARTNER_API_ROUTES = {
  auth: {
    login: '/api/partner/auth/login',
    setPassword: '/api/partner/auth/set-password',
    forgotPassword: '/api/partner/auth/forgot-password',
    resetPassword: '/api/partner/auth/reset-password',
    changePassword: '/api/partner/auth/change-password',
    changeEmail: '/api/partner/auth/change-email',
    confirmEmailChange: '/api/partner/auth/confirm-email-change',
    me: '/api/partner/auth/me',
  },
  enquiry: {
    submit: '/api/partner-enquiry',
  },
};
